var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13842_114738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.375 24C19.0024 24 24.375 18.6274 24.375 12C24.375 5.37258 19.0024 0 12.375 0C5.74758 0 0.375 5.37258 0.375 12C0.375 18.6274 5.74758 24 12.375 24Z",
    fill: "url(#paint0_linear_13842_114738)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.80701 11.873C9.30526 10.3488 11.638 9.34403 12.8051 8.85856C16.1377 7.47245 16.8301 7.23167 17.2815 7.22372C17.3808 7.22197 17.6027 7.24657 17.7465 7.36323C17.8679 7.46174 17.9013 7.59481 17.9173 7.68821C17.9333 7.7816 17.9532 7.99436 17.9373 8.16061C17.7567 10.0581 16.9753 14.6628 16.5778 16.788C16.4096 17.6872 16.0784 17.9888 15.7577 18.0183C15.0608 18.0824 14.5317 17.5577 13.8567 17.1153C12.8006 16.423 12.2039 15.992 11.1787 15.3164C9.99396 14.5357 10.762 14.1066 11.4372 13.4053C11.6139 13.2217 14.6843 10.429 14.7437 10.1756C14.7512 10.144 14.7581 10.0258 14.6879 9.96348C14.6177 9.90111 14.5142 9.92244 14.4394 9.9394C14.3335 9.96344 12.6463 11.0786 9.37776 13.285C8.89885 13.6138 8.46507 13.7741 8.07641 13.7657C7.64795 13.7564 6.82376 13.5234 6.21106 13.3242C5.45956 13.08 4.86228 12.9508 4.91429 12.5359C4.94138 12.3198 5.23895 12.0989 5.80701 11.873Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13842_114738",
    x1: 12.375,
    y1: 0,
    x2: 12.375,
    y2: 23.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13842_114738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.375)"
  })))));
};
export default SvgTelegram;